export default "__VITE_ASSET__DfcG6Eua__"